import alt from "../alt";

class DeviceStatusActions {
  fetch() {
    return "nothing";
  }

  fetchUpdated(activity) {
    return activity;
  }
}

export default alt.createActions(DeviceStatusActions);
